export default "__VITE_ASSET__Bvl5cJN5__"